import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import PrimeVue from 'primevue/config'

import {
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
  Menu as UiMenu,
  MenuButton,
  MenuItem,
  MenuItems,
  RadioGroup,
  RadioGroupLabel,
  RadioGroupOption,
  TransitionChild,
  TransitionRoot,
  Dialog as UiDialog,
  SwitchGroup,
  SwitchLabel
} from '@headlessui/vue'

import InlineHelp from "../../../../app/frontend/components/InlineHelp.vue"
import Multiselect from "../../../../app/frontend/components/Multiselect.vue"
import GroupedMultiselect from '../../../../app/frontend/components/GroupedMultiselect.vue'
import SearchForm from "../../../../app/frontend/components/SearchForm.vue"
import SearchFCriterionFields from "../../../../app/frontend/components/SearchCriterionFields.vue"
import ToggleSwitch from "../../../../app/frontend/components/ToggleSwitch.vue"
import Bookmark from '../../../../app/frontend/components/Bookmark.vue'
import MorePopover from '../../../../app/frontend/components/MorePopover.vue'
import CalendarPopover from '../../../../app/frontend/components/CalendarPopover.vue'

import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'

export default class extends Controller {
  static values = { remountTurboFrame: String }

  connect() {
    document.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this));
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this));

    // Don't unmount Vue if this is during a drag operation
    const isDragging = this.element.classList.contains('ui-sortable-helper') ||
                      this.element.classList.contains('ui-sortable-placeholder') ||
                      document.body.classList.contains('ui-sortable-dragging')

    if (this.app && !isDragging) {
      this.app.unmount()
    }
  }

  handleFrameLoad(event) {
    const mountPointElement = event.target.children[0];
    console.log('remount_turbo_frame: ', mountPointElement)

    // Only mount once - but also check if the app instance still exists
    if (mountPointElement.dataset.vueRemounted === "true" && this.app && this.app._instance) {
      return
    }

    // Apr 2025: this will remount vue to the element that is replaced by turbo stream
    this.app = createApp({
      template: mountPointElement.innerHTML || '<div></div>'
    })
    
    this.app
      .component('dialogpanel', DialogPanel)
      .component('disclosure', Disclosure)
      .component('disclosurebutton', DisclosureButton)
      .component('disclosurepanel', DisclosurePanel)
      .component('listbox', Listbox)
      .component('listboxbutton', ListboxButton)
      .component('listboxlabel', ListboxLabel)
      .component('listboxoption', ListboxOption)
      .component('listboxoptions', ListboxOptions)
      .component('menubutton', MenuButton)
      .component('menuitem', MenuItem)
      .component('menuitems', MenuItems)
      .component('multiselect', Multiselect)
      .component('groupedmultiselect', GroupedMultiselect)
      .component('tab', Tab)
      .component('tabs', Tabs)
      .component('tablist', TabList)
      .component('tabpanels', TabPanels)
      .component('tabpanel', TabPanel)
      .component('transitionchild', TransitionChild)
      .component('transitionroot', TransitionRoot)
      .component('toggleswitch', ToggleSwitch)
      .component('switchgroup', SwitchGroup)
      .component('switchlabel', SwitchLabel)
      .component('uidialog', UiDialog)
      .component('uimenu', UiMenu)
      .component('inlinehelp', InlineHelp)
      .component('searchform', SearchForm)
      .component('searchfcriterionfields', SearchFCriterionFields)
      .component('bookmark', Bookmark)
      .component('morepopover', MorePopover)
      .component('calendarpopover', CalendarPopover)

    this.app.use(PrimeVue, { unstyled: true })
    this.app.mount(mountPointElement)

    // Mark as mounted AFTER Vue has mounted
    mountPointElement.dataset.vueRemounted = "true"
  }
}
